type SelectablePageDomain = {
    id: number;
    is_default: boolean;
    team_id: number;
};

/**
 * The default domain of the event type's own team. Domains borrowed from the
 * team owner's personal team only apply when assigned explicitly.
 */
export function getTeamDefaultPageDomain<T extends SelectablePageDomain>(
    pageDomains: T[],
    teamId: number,
): T | undefined {
    return pageDomains.find(
        (pageDomain) => pageDomain.is_default && pageDomain.team_id === teamId,
    );
}

/**
 * Mirrors the backend URL resolution: an assigned domain wins while it is
 * verified (pageDomains lists only verified ones), otherwise the team's
 * default domain is used, otherwise zapti.me (null).
 */
export function getSelectedPageDomainId(
    assignedPageDomainId: number | null,
    pageDomains: SelectablePageDomain[],
    teamId: number,
): number | null {
    if (
        pageDomains.some((pageDomain) => pageDomain.id === assignedPageDomainId)
    ) {
        return assignedPageDomainId;
    }

    return getTeamDefaultPageDomain(pageDomains, teamId)?.id ?? null;
}
